export default {
	// Notices
	errors: state => {
		return state.errors;
	},
	notices: state => {
		return state.notices;
	},
	loading: state => {
		let isLoading = false;
		Object.keys(state.loading).forEach(function(name){
			if(!isLoading && state.loading[name]) isLoading = true;
		});
		return isLoading;
	},
	loadings: state => {
		return state.loading;
	},
	devmode: state => {
		return state.devmode;
	},
};



// WEBPACK FOOTER //
// ./src/store/core/getters.js